<template>
  <div class="step-list">
    <el-steps class="step-container" simple :active="activeIndex">
      <el-step
        v-for="(step, index) in stepList"
        class="step"
        :key="index"
        :title="step.title"
      >
        <template #icon>
          <i v-show="showIcon" :class="step.icon || defaultIconClass"></i>
        </template>
      </el-step>
    </el-steps>
  </div>
</template>

<script>

export default {
  props: {
    stepList: {
      type: Array,
      required: true
    },
    activeIndex: {
      type: Number,
      required: true
    },
    showIcon: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      defaultIconClass: 'el-icon-delete'
    }
  },
  computed: {

  },
  methods: {

  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
.step-list {
  .step-container {
    padding: 22px 36px;

    .step {
      flex: 1;
      flex-basis: auto !important;

      ::v-deep {
        .el-step__head {
          padding: 0px;

          .el-step__icon.is-text {
            border: 0;
            display: none;
          }
        }

        .el-step__main {
          flex: 1;

          .el-step__title {
            flex: 1;
            font-size: 18px;
            word-break: normal;
            max-width: 100%;
            text-align: center;
          }

          .el-step__arrow {
            margin: 0;
            padding: 0 20px;
            flex-grow: 0;
          }

          .el-step__title.is-process {
            color: #0096CC
          }

          .el-step__title.is-wait {
            color: #909399
          }

          .el-step__title.is-finish {
            color: #606266
          }
        }
      }
    }
  }
}
</style>
